module.exports = __webpack_public_path__ + "static/media/ds-8-powermatic_03.d4051ed6.png";